module.exports = __webpack_public_path__ + "images/US_Foods_Holding-4752d9.png";